import React, { useState, ReactElement, cloneElement } from 'react'
import {
  Popover,
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'

interface PopConfirmProps {
  children: ReactElement
  onConfirm: () => void
  title?: string
  description?: string
  okText?: string
  cancelText?: string
  loading?: boolean
}

export const PopConfirm: React.FC<PopConfirmProps> = ({
  children,
  onConfirm,
  title = 'Confirmer la suppression',
  description = 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  okText = 'Supprimer',
  cancelText = 'Annuler',
  loading = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleConfirm = () => {
    onConfirm()
    handleClose()
  }

  return (
    <>
      {cloneElement(children, {
        onClick: handleClick,
      })}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          elevation: 8,
        }}
      >
        <Paper sx={{ p: 2, maxWidth: 280 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <WarningIcon color="warning" fontSize="small" />
            <Typography variant="subtitle2" fontWeight="medium">
              {title}
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {description}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button size="small" onClick={handleClose} variant="outlined">
              {cancelText}
            </Button>
            <Button 
              size="small" 
              onClick={handleConfirm} 
              variant="contained" 
              color="error"
              disabled={loading}
            >
              {okText}
            </Button>
          </Box>
        </Paper>
      </Popover>
    </>
  )
}